import BasicModal from '@/shared/ui/Modal'
import { useSharedStyles } from '@/pages/Settings/useSharedStyles'
import { PlusIcon } from '@/shared/ui'
import { Box, Button, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface Props {
    isModalOpen: boolean
    deviceId?: string | null
    alias?: string | null
    closeModal: () => void
    deviceDeactivate: (deviceId?: string | null) => void
}

const DeviceDeactivatesModal = ({
    isModalOpen,
    closeModal,
    alias,
    deviceId,
    deviceDeactivate,
}: Props) => {
    const theme = useTheme()
    const { titleStyle } = useSharedStyles()
    const { t: translate } = useTranslation()

    const styles = {
        modalContainer: {
            maxWidth: '60vw',
            maxHeight: '60vw',
        },
        cancelButton: {
            marginTop: '12px',
            width: '100%',
            height: '36px',
            padding: '8px 12px',
            gap: '8px',
            borderRadius: '10px',
            bgcolor: 'transparent',
            border: '1px solid white',
            color: 'white',
        },
        confirmButton: {
            marginTop: '12px',
            width: '100%',
            height: '36px',
            padding: '8px 12px',
            gap: '8px',
            borderRadius: '10px',
            bgcolor: 'primary.main',
        },
        aliasText: {
            fontVariant: 'all-petite-caps',
            display: 'inline-block',
            marginX: '.5rem',
            fontSize: '20px',
        },
    }

    return (
        <BasicModal
            isOpen={isModalOpen}
            setIsModalOpen={closeModal}
            styles={styles.modalContainer}>
            <Button onClick={closeModal} sx={{ transform: 'rotate(45deg)' }}>
                <PlusIcon fill={theme.palette.primary.main} />
            </Button>
            <Box width="100%" sx={{ color: '#fff' }}>
                <Typography
                    sx={{
                        ...titleStyle,
                        marginY: '1rem',
                        fontSize: '20px',
                    }}>
                    {translate('settingsPageDeviceDeactivatesModalTitle')}:
                    <Typography sx={styles.aliasText}>
                        {alias || deviceId}
                    </Typography>
                </Typography>
                <Box display="flex" columnGap="16px" mt="16px">
                    <Button
                        data-testid="accept-button"
                        disabled={!deviceId}
                        sx={styles.confirmButton}
                        onClick={() => deviceDeactivate(deviceId)}>
                        <Typography color="white" variant="label4">
                            {translate('accept')}
                        </Typography>
                    </Button>
                    <Button
                        data-testid="cancel-button"
                        variant="outlined"
                        sx={styles.cancelButton}
                        onClick={closeModal}>
                        <Typography color="white" variant="label4">
                            {translate('globalCancel')}
                        </Typography>
                    </Button>
                </Box>
            </Box>
        </BasicModal>
    )
}

export { DeviceDeactivatesModal }
